import React from 'react'
import { BANKING_BOTTOM_CONTENT, CYBER_COURSE_PAGE_2, CYBER_DETAILS_PAGE_2, CYBER_HERO_PAGE_2 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { CYBER_ACCORDIAN_2 } from '../../../utils/courseConifg'

const CyberPage_2 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...CYBER_HERO_PAGE_2}/>
     <CoursesAside {...CYBER_COURSE_PAGE_2}/>
     <CourseCard {...CYBER_DETAILS_PAGE_2}/>
     <Accordian {...CYBER_ACCORDIAN_2}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default CyberPage_2